import { render, staticRenderFns } from "./InputTextColor.vue?vue&type=template&id=0646787f&scoped=true&"
import script from "./InputTextColor.vue?vue&type=script&lang=js&"
export * from "./InputTextColor.vue?vue&type=script&lang=js&"
import style0 from "./InputTextColor.vue?vue&type=style&index=0&lang=css&"
import style1 from "./InputTextColor.vue?vue&type=style&index=1&id=0646787f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0646787f",
  null
  
)

export default component.exports